let cacheImages = new Map();

export function insertImages(images) {
  for (const image of images) {
    insertImage(image);
  }
}

export function insertImage(image) {
  cacheImages.set(image.id, image.dataUrl);
}

export function getImageById(id) {
  return cacheImages.get(id);
}

export function deleteImageById(id) {
  cacheImages.delete(id);
}



// WEBPACK FOOTER //
// ./src/services/image-caching.js